// extracted by mini-css-extract-plugin
export default {"formTopOffset":"styles_formTopOffset__3+lkw"};